import React, { Fragment, useEffect, useState } from 'react'
import { updateProductTypeAction } from '../../redux/actions/userActions';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

const UpdateProductType = ({ type, setShowEditPage, setSelectedType }) => {




    const dispatch = useDispatch()


    const [name, setName] = useState("");
    const [complexity_level, setComplexityLevel] = useState("");
    const [portal_commission, setPortalCommission] = useState("");
        const [pm_commission, setPmCommission] = useState("");
    




    const handleSubmit = (e) => {
        e.preventDefault();
        if (!name) return toast.error("Please enter product type name");
        if (!complexity_level) return toast.error("Please select complexity level");
        if (!portal_commission) return toast.error("Please enter portal commission");
        if (!pm_commission) return toast.error("Please enter PM commission");
        dispatch(updateProductTypeAction({ id: type.id, name, complexity_level, portal_commission, pm_commission }));
    };



    useEffect(() => {
        if (type) {
            setName(type.name);
            setComplexityLevel(type.complexity_level);
            setPortalCommission(type.portal_commission);
            setPmCommission(type.pm_commission);
        }
    }, [type]);


    return (
        <Fragment>
            <section className="fixed inset-0 z-[999999998] bg-black/40 backdrop-blur-sm flex justify-center items-center" >

                <div className="w-[90%] lg:w-[25%]  bg-white rounded-2xl p-[1.5vmax] shadow-2xl animate-[fadeIn_.2s_ease] ">

                    <div className="text-right">
                        <button onClick={() => {
                            setShowEditPage(false);
                            setSelectedType(null);
                        }} className="text-gray-500 hover:text-gray-700 transition-colors duration-200">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <div className='flex flex-col mt-[1vmax]'>
                        <span className='text-[1.5vmax] lg:text-[1vmax]'>Product Type Name <span className='text-red-500'>*</span></span>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className='px-[2vmax] py-[0.7vmax] rounded-[2vmax] border-[0.12vmax] mt-[0.7vmax] outline-blue-400 text-[1.8vmax] lg:text-[0.9vmax] font-[500] bg-[#f5f5f5]'
                            placeholder='ex. Text Review'
                        />
                    </div>
                        <div className='flex flex-col mt-[1vmax]'>
                        <span className='text-[1.5vmax] lg:text-[1vmax]'>PM Commission (PKR) <span className='text-red-500'>*</span></span>
                        <input
                            type="number"
                            value={pm_commission}
                            onChange={(e) => setPmCommission(e.target.value)}
                            className='px-[2vmax] py-[0.7vmax] rounded-[2vmax] border-[0.12vmax] mt-[0.7vmax] outline-blue-400 text-[1.8vmax] lg:text-[0.9vmax] font-[500] bg-[#f5f5f5]'
                            placeholder='ex. 900'
                        />
                    </div>
                    <div className='flex flex-col mt-[1vmax]'>
                        <span className='text-[1.5vmax] lg:text-[1vmax]'>Portal Commission (PKR) <span className='text-red-500'>*</span></span>
                        <input
                            type="number"
                            value={portal_commission}
                            onChange={(e) => setPortalCommission(e.target.value)}
                            className='px-[2vmax] py-[0.7vmax] rounded-[2vmax] border-[0.12vmax] mt-[0.7vmax] outline-blue-400 text-[1.8vmax] lg:text-[0.9vmax] font-[500] bg-[#f5f5f5]'
                            placeholder='ex. 200'
                        />
                    </div>
                    <div className='flex flex-col mt-[1vmax]'>
                        <span className='text-[1.5vmax] lg:text-[1vmax]'>Complexity Level <span className='text-red-500'>*</span></span>
                        <select
                            value={complexity_level}
                            onChange={(e) => setComplexityLevel(e.target.value)}
                            className='px-[2vmax] py-[0.7vmax] rounded-[2vmax] border-[0.12vmax] mt-[0.7vmax] outline-blue-400 text-[1.8vmax] lg:text-[0.9vmax] font-[500] bg-[#f5f5f5]'
                        >
                            <option value="">--Select Complexity Level--</option>
                            <option value="easy">easy</option>
                            <option value="medium">medium</option>
                            <option value="complex">complex</option>
                        </select>
                    </div>
                    <br />
                    <button onClick={handleSubmit} className='w-full bg-blue-500 hover:bg-blue-600 text-white py-[0.7vmax] rounded-[2vmax] text-[1.8vmax] lg:text-[0.9vmax] font-[500] transition-colors duration-200'>
                        Update Product Type
                    </button>
                </div>

            </section>
        </Fragment>
    )
}

export default UpdateProductType
